module.exports = __webpack_public_path__ + "static/specificImplant-984eda90839d1368b668061dcbefc408.jpg";